import { Button } from "@ps-design-system/components/Button";
import { Text } from "@ps-design-system/components/Text";
import { FormattedMessage } from "react-intl";
import LoftIcon from "@ps-design-system/icons/Loft/Loft20";
import ChefIcon from "@ps-design-system/icons/Chef/Chef20";

type SpacesServicesHeaderProps = {
  activeFilter: string;
  onSelectFilter: (filter: string) => void;
};

const SpacesServicesHeader = ({
  activeFilter,
  onSelectFilter,
}: SpacesServicesHeaderProps) => {
  return (
    <div>
      <h2 className="tw-mb-16">
        <FormattedMessage
          id="hosting.my_listings.banner_heading"
          defaultMessage="Listings"
        />
      </h2>
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-8">
          <Button
            shape="pill"
            appearance="white"
            className={
              "all" === activeFilter
                ? "tw-bg-gray-100 tw-border-[1.5px] tw-border-gray-900"
                : ""
            }
            onClick={() => onSelectFilter("all")}
          >
            <Text typeface="body-1-m">
              <FormattedMessage id="vendor.edit.all" defaultMessage="All" />
            </Text>
          </Button>
          <Button
            shape="pill"
            className={
              "spaces" === activeFilter
                ? "tw-bg-gray-100 tw-border-[1.5px] tw-border-gray-900"
                : ""
            }
            onClick={() => onSelectFilter("spaces")}
          >
            <Text typeface="body-1-m">
              <FormattedMessage
                id="vendor.edit.spaces"
                defaultMessage="Spaces"
              />
            </Text>
          </Button>
          <Button
            shape="pill"
            className={
              "services" === activeFilter
                ? "tw-bg-gray-100 tw-border-[1.5px] tw-border-gray-900"
                : ""
            }
            onClick={() => onSelectFilter("services")}
          >
            <Text typeface="body-1-m">
              <FormattedMessage
                id="vendor.edit.services"
                defaultMessage="Services"
              />
            </Text>
          </Button>
        </div>
        <div className="tw-hidden md:tw-flex md:tw-items-center md:tw-gap-8">
          {"services" !== activeFilter && (
            <Button
              href="/your-space"
              appearance="white"
              variant="outline-2"
              prefix={<LoftIcon />}
            >
              <Text typeface="body-2-m">
                <FormattedMessage
                  id="vendor.edit.add_a_space"
                  defaultMessage="Add a space"
                />
              </Text>
            </Button>
          )}
          {"spaces" !== activeFilter && (
            <Button
              appearance="white"
              variant="outline-2"
              prefix={<ChefIcon />}
              href="https://hosts.trypeerspace.com/peerspace-vendor-onboarding"
            >
              <Text typeface="body-2-m">
                <FormattedMessage
                  id="vendor.edit.add_a_service"
                  defaultMessage="Add a service"
                />
              </Text>
            </Button>
          )}
        </div>
      </div>
      <hr className="tw-my-24" />
    </div>
  );
};

export default SpacesServicesHeader;
